module.exports = __webpack_public_path__ + "static/media/loginback.39d46b2b.png";